import React from "react";
import {Modal, ScrollView, View, Image, TouchableOpacity} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import Btn from "../components/Btn";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import ErrorIcon from "../assets/img/icons/error icon.svg";
import WarnIcon from "../assets/img/icons/warn-icon.svg";
import TicketIcon from "../assets/img/dollar-exclamation.svg";
import {FullSwingInfoModalProps} from "../types";

type Props = { info: FullSwingInfoModalProps, onRequestClose: () => void };

const FullSwingInfoModal = (props: Props) => {
  const {info} = props;
  const isConfirmFlow = !!info.onConfirm && !!info.warningText;

  return (
    <Modal animationType="fade" transparent visible={info.visible} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onRequestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>{info.title}</P>

                {info.showCloseIcon && (
                  <View style={{position: "absolute", right: 10}}>
                    <TouchableOpacity onPress={props.onRequestClose}>
                      <Image
                        source={require("../assets/img/icons/icon_close.png")}
                        style={{width: 28, height: 28}}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </Div>

              <Div px={16} pb={30} pt={40} alignItems="center">
                <Div position="relative" p={5} mb={info.warningText ? 24 : 10}>
                  {info.warnIcon ? (
                    <Image source={WarnIcon as any} style={{width: 50.768, height: 45.125}}/>
                  ) : info.errorIcon ? (
                    <Image source={ErrorIcon as any} style={{width: 48, height: 48}}/>
                  ) : info.ticketIcon ? (
                    <Image source={TicketIcon as any} style={{width: 52, height: 52}}/>
                  ) : info.successIcon ? (
                    <Div w={47} h={47} rounded={30} bg="#1E9428" alignItems="center" justifyContent="center">
                      <FontAwesome5 name="check" size={30} color="white"/>
                    </Div>
                  ) : (
                    <FontAwesome5 name="info-circle" size={48} color="#3369FF"/>
                  )}

                  {(!info.warnIcon && !info.ticketIcon) && (
                    <Div position="absolute" top={15} right={15} bottom={15} left={15} bg="white" zIndex={-1}/>
                  )}
                </Div>

                <P fontFamily="DavisSans-Regular" ta="center" mb={40}>{info.subtitle}</P>

                {info.secondSubtitle && <P fontFamily="DavisSans-Regular" ta="center" mb={30}>{info.secondSubtitle}</P>}

                {info.noteText && (
                  <P fontStyle="italic" ta="center" color="#76777A" mb={40} fs={15}>{info.noteText}</P>
                )}

                {info.warningText && (
                  <P fontFamily="DavisSans-Regular" ta="center" color="#F55656" mb={40}>{info.warningText}</P>
                )}

                {isConfirmFlow ? (
                  <>
                    <Btn mb={30} bg="#C73232" rounded={4} onPress={info.onConfirm} w="100%">
                      <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Turn Off</P>
                    </Btn>

                    <Btn onPress={props.onRequestClose} w="100%">
                      <P ta="center" textDecorationLine="underline" fontFamily="DavisSans-Regular" color="white"
                         lh={24}>
                        Cancel
                      </P>
                    </Btn>
                  </>
                ) : (
                  <Btn bg="#3369FF" onPress={info.onConfirm || props.onRequestClose} w="100%">
                    <P fontFamily="DavisSans-Medium" lh={56} ta="center">{info.confirmText || 'Got it!'}</P>
                  </Btn>
                )}
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default FullSwingInfoModal;
